"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rsDropdownMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _ = require("../");

var _index = require("../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["__content"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["--clean --content-gray --focus:", " --circle:", " --small:", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// DotsDropdownIndicator.propTypes = { isFocused: PropTypes.bool.isRequired };
// MenuOption.propTypes = {
//   data: PropTypes.shape({ isAvailable: PropTypes.bool }).isRequired,
//   label: PropTypes.string.isRequired,
// };
var rsDropdownMenu = function rsDropdownMenu() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$auto = _ref.auto,
      auto = _ref$auto === void 0 ? false : _ref$auto;

  return {
    styles: {
      menu: function menu(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          // display: 'flex',
          padding: '0',
          border: '1px solid #d1d4e4',
          borderRadius: 3,
          backgroundColor: '#ffffff',
          boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.1)',
          width: 'auto',
          marginTop: '2px',
          marginBottom: '2px',
          minWidth: 'auto'
        }, auto ? {} : {
          position: 'absolute',
          right: '0'
        });
      },
      indicatorSeparator: function indicatorSeparator(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          display: 'none'
        });
      },
      valueContainer: function valueContainer(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          border: '0',
          maxWidth: '0',
          padding: '0',
          opacity: '0'
        });
      },
      control: function control(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          borderWidth: '0',
          boxShadow: '0',
          minHeight: 'auto',
          backgroundColor: 'transparent'
        });
      },
      dropdownIndicator: function dropdownIndicator(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          padding: '0'
        });
      },
      menuList: function menuList(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          display: 'flex',
          flexDirection: 'column',
          margin: '0',
          padding: '0',
          overflowX: 'hidden'
        });
      },
      option: function option(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          cursor: 'pointer',
          paddingRight: '25px',
          whiteSpace: 'nowrap',
          flexWrap: 'nowrap'
        });
      }
    },
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      Placeholder: function Placeholder() {
        return null;
      },
      SingleValue: function SingleValue() {
        return null;
      }
    },
    componentsAll: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      Placeholder: function Placeholder() {
        return null;
      },
      SingleValue: function SingleValue() {
        return null;
      },
      DropdownIndicator: function DropdownIndicator(_ref2) {
        var _ref2$menuButtonConte = _ref2.menuButtonContent,
            menuButtonContent = _ref2$menuButtonConte === void 0 ? null : _ref2$menuButtonConte,
            _ref2$isSmall = _ref2.isSmall,
            isSmall = _ref2$isSmall === void 0 ? false : _ref2$isSmall,
            _ref2$isCircle = _ref2.isCircle,
            isCircle = _ref2$isCircle === void 0 ? false : _ref2$isCircle;
        return function (_ref3) {
          var isFocused = _ref3.isFocused,
              props = _objectWithoutProperties(_ref3, ["isFocused"]);

          return /*#__PURE__*/_react.default.createElement(_reactSelect.components.DropdownIndicator, _extends({
            isFocused: isFocused
          }, props, (0, _.ui)([(0, _.uiButton)(_templateObject(), isFocused, isCircle, isSmall)])), /*#__PURE__*/_react.default.createElement("span", (0, _.ui)([(0, _.uiButton)(_templateObject2())]), menuButtonContent));
        };
      },
      Option: function Option() {
        return function (_ref4) {
          var _ref4$data = _ref4.data,
              isAvailable = _ref4$data.isAvailable,
              data = _objectWithoutProperties(_ref4$data, ["isAvailable"]),
              label = _ref4.label,
              props = _objectWithoutProperties(_ref4, ["data", "label"]);

          return isAvailable ? /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, _extends({
            data: _objectSpread({
              isAvailable: isAvailable
            }, data),
            label: label
          }, props, {
            isSelected: false
          }), /*#__PURE__*/_react.default.createElement("span", null, label)) : '';
        };
      }
    },
    theme: function theme(_theme) {
      return _objectSpread(_objectSpread({}, _theme), {}, {
        borderRadius: 3,
        colors: _objectSpread(_objectSpread({}, _theme.colors), {}, {
          primary25: _index.UI_COLOR_PALE_BLUE,
          primary: _index.UI_COLOR_PALE_BLUE
        })
      });
    }
  };
};

exports.rsDropdownMenu = rsDropdownMenu;